import { useState } from 'react';
import { Link } from 'react-router-dom';
import useIsCurrentPath from '../../../hooks/useIsCurrentPath';
import { useLayoutStore } from '../../../state/useLayoutStore';
import { getMenuOptions } from '../../../helpers/utls';
import routes from '../../../config/routes';
import { cn } from '../../../lib/utils';
import Logo from '../../../img/logo.png';
import SearchBar from '../../../components/CatalogProducts/SearchBar';
import useHeaderScroll from './useHeaderScroll';
import DesktopNav from './DesktopNav';
import MobileNav from './MobileNav';

const menuOptions = getMenuOptions();

const Header = () => {
  const isModeModal = useLayoutStore(s => s.isModeModal);
  const inHomePath = useIsCurrentPath('/');
  const inProductsPath = useIsCurrentPath(routes.publicRoutes.products.path);
  const inProductPath = useIsCurrentPath(routes.publicRoutes.product.path);

  const [mobileOpen, setMobileOpen] = useState(false);
  const [desktopMenuOpen, setDesktopMenuOpen] = useState(false);

  const isOpen = mobileOpen || desktopMenuOpen;
  const { slideIn, transparent, mouseHandlers } = useHeaderScroll(
    inHomePath && !isModeModal,
    isOpen,
  );

  return (
    <header
      className={cn(
        'fixed top-0 left-0 right-0 z-50 transition-all duration-400 ease-out text-white',
        !slideIn && '-translate-y-full',
        transparent ? 'bg-transparent bg-gradient-to-b from-black/50 to-transparent' : 'bg-primary',
      )}
      {...mouseHandlers}
    >
      <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-10">
        <div className="flex h-16 items-center justify-between gap-3 lg:h-20 lg:gap-6">
          <Link
            to={routes.homeRoute.path}
            aria-label="Ir al inicio"
            className="flex items-center gap-2.5 shrink-0 focus-visible:outline-2 focus-visible:outline-white focus-visible:outline-offset-2 rounded-sm"
          >
            <img src={Logo} alt="" className="h-9 lg:h-11 object-contain" />
            <span className="hidden text-lg font-extrabold tracking-wide text-inherit lg:inline lg:text-xl">
              TELME
            </span>
          </Link>

          {(inProductsPath || inProductPath) && (
            <div className="min-w-0 max-w-xs flex-1 sm:max-w-sm lg:max-w-md">
              <SearchBar />
            </div>
          )}

          <DesktopNav items={menuOptions} onMenuOpenChange={setDesktopMenuOpen} />

          <MobileNav
            items={menuOptions}
            open={mobileOpen}
            onToggle={() => setMobileOpen(v => !v)}
            onClose={() => setMobileOpen(false)}
          />
        </div>
      </div>
    </header>
  );
};

export default Header;
